import React from "react";

export const EmaarFloatingButtons = () => {
  const phoneNumber = "+971523844444";   // رقم الاتصال - غيّره
  const whatsappNumber = "971523844444"; // رقم الواتساب (بدون + أو 00) - غيّره
  const whatsappMessage = "Hello, I'm interested in Emaar properties.";

  return (
    <div className="efb-wrap">
      
       <a href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="efb-btn efb-whatsapp"
        aria-label="Chat on WhatsApp"
      >
        <span className="efb-ring" />
        <span className="efb-ring efb-ring-delay" />
        <span className="efb-icon">
          <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor">
            <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.86.5 3.6 1.4 5.12L2 22l5.13-1.5a9.9 9.9 0 0 0 4.9 1.27h.01c5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm5.86 14.06c-.25.7-1.45 1.36-2.01 1.45-.51.08-1.16.11-1.87-.12-.43-.14-.98-.32-1.7-.62-2.98-1.29-4.93-4.3-5.08-4.5-.15-.2-1.22-1.62-1.22-3.09 0-1.47.77-2.19 1.05-2.49.27-.3.6-.37.8-.37.2 0 .4 0 .57.01.18.01.43-.07.67.51.25.6.84 2.07.92 2.22.07.15.12.33.02.53-.1.2-.15.32-.3.49-.15.18-.32.4-.45.54-.15.15-.3.32-.13.62.18.3.8 1.32 1.72 2.14 1.18 1.06 2.18 1.39 2.49 1.55.31.15.49.13.67-.06.18-.2.78-.9.99-1.21.2-.3.4-.25.67-.15.27.1 1.7.81 1.99.96.3.15.49.22.56.34.07.13.07.74-.18 1.45z"/>
          </svg>
        </span>
      </a>

      
       <a href={`tel:${phoneNumber}`}
        className="efb-btn efb-call"
        aria-label="Call us"
      >
        <span className="efb-ring efb-ring-gold" />
        <span className="efb-icon">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
        </span>
      </a>

      <style>{`
        .efb-wrap {
          position: fixed;
          bottom: 28px;
          left: 18px;
          display: flex;
          flex-direction: column;
          gap: 16px;
          z-index: 9999;
        }

        .efb-btn {
          position: relative;
          width: 58px;
          height: 58px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          color: #0f1115;
          box-shadow: 0 6px 18px rgba(0,0,0,0.35), 0 0 0 1px rgba(201,162,90,0.25);
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }

        .efb-btn:hover {
          transform: translateY(-3px) scale(1.05);
          box-shadow: 0 10px 26px rgba(0,0,0,0.45), 0 0 0 1px rgba(201,162,90,0.45);
        }

        .efb-whatsapp {
          background: linear-gradient(145deg, #1f2a23, #16201a);
          color: #c9a25a;
          border: 1px solid rgba(201,162,90,0.35);
        }

        .efb-call {
          background: linear-gradient(145deg, #16181d, #0c0d10);
          color: #c9a25a;
          border: 1px solid rgba(201,162,90,0.35);
        }

        .efb-icon {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .efb-ring {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          border: 1.5px solid rgba(37, 211, 102, 0.65);
          animation: efb-pulse 2.2s ease-out infinite;
        }

        .efb-ring-delay {
          animation-delay: 1.1s;
        }

        .efb-ring-gold {
          border-color: rgba(201, 162, 90, 0.65);
        }

        @keyframes efb-pulse {
          0% { transform: scale(1); opacity: 0.75; }
          70% { transform: scale(1.55); opacity: 0; }
          100% { transform: scale(1.55); opacity: 0; }
        }

        @media (max-width: 480px) {
          .efb-wrap { bottom: 18px; right: 16px; gap: 12px; }
          .efb-btn { width: 50px; height: 50px; }
        }
      `}</style>
    </div>
  );
};